import 'animate.css';
import { SimpleBubble } from "./SimpleBubble";


export const Bubble = () => {
  return <SimpleBubble />;
}
